/* ContentTypeComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./ContentTypeRenderer");
const _ = require("lodash");

class ContentTypeComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._entity = value;
        this._contentTypeLabels = this._entity.getContentTypeLabels();
        this._value = this._entity.getContentType();
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    _registerListeners() {}

    _unregisterListeners() {}

    get renderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        const prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._entity = undefined;
        this._contentTypeLabels = undefined;
        return prom;
    }

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.emit("ValueUpdated", this._value);
            return this;
        }
    }

    getValue() {
        return this._value;
    }
}

module.exports = ContentTypeComponent;
